import { MobileBottomTabs } from "components/navigation";
import { getDefaultOrdersQueryArgs } from "components/orders/ordersQueryDefaults";
import { Slot, Tabs } from "expo-router";
import React, { useEffect } from "react";
import { Platform } from "react-native";
import { abcoApi } from "store/abcoApi";
import { useBasicUser } from "utils/hooks/useBasicUser";

// Long enough for the dashboard's own requests to go out first; these should
// fill the cache in the background, not compete with the screen on show.
const PREFETCH_DELAY_MS = 2000;

// Warms the Sites, Orders and Notifications caches once the user is signed in,
// with the exact args each screen's first render uses, so tapping a tab opens
// a populated screen instead of a skeleton. Cheap to get wrong: a mismatched
// key is just one extra request.
function TabDataPrefetch() {
	const { isSignedIn } = useBasicUser();
	const prefetchSites = abcoApi.usePrefetch("getSites");
	const prefetchOrders = abcoApi.usePrefetch("getOrder");
	const prefetchNotifications = abcoApi.usePrefetch("getNotification");

	useEffect(() => {
		if (!isSignedIn) return;
		const timer = setTimeout(() => {
			prefetchSites({ pageNumber: 1, searchTerm: undefined, sortField: "Name" as any, sortDirection: "asc", pageSize: 10, groupIdCollection: [] });
			prefetchOrders(getDefaultOrdersQueryArgs());
			prefetchNotifications({ pageNumber: 1, eventTypeIdCollection: [], hasRead: undefined, groupIdCollection: [] });
		}, PREFETCH_DELAY_MS);
		return () => clearTimeout(timer);
	}, [isSignedIn, prefetchSites, prefetchOrders, prefetchNotifications]);

	return null;
}

// Native: a real bottom-tab navigator, so Home / Sites / Orders / Cart each
// keep their own stack and state and switch instantly. Web: pure passthrough
// — the (pages) layout already renders the header and the mobile-web bottom
// bar, and URLs are unchanged because (tabs) is a route group.
export default function TabsLayout() {
	if (Platform.OS === "web") {
		return <Slot />;
	}

	return (
		<>
			<TabDataPrefetch />
			<Tabs tabBar={(props) => <MobileBottomTabs tabBarProps={props} />} screenOptions={{ headerShown: false }}>
				<Tabs.Screen name="index" />
				<Tabs.Screen name="sites" />
				<Tabs.Screen name="orders" />
				<Tabs.Screen name="cart" />
			</Tabs>
		</>
	);
}
